module.exports = __webpack_public_path__ + "b1de0d9a13673a412dd42144f4a23dd6.webp";